<template>
    <div class="flex p-6">
        <vue-cal
            id="vueCalRightClick"
            ref="vuecal"
            :time-from="8 * 60"
            :time-to="22 * 60"
            :snap-to-time="15"
            :editable-events="{title: false, drag: true, resize: true, delete: false, create: true}"
            resize-x
            :events="events"
            :min-event-width="minEventWidth"
            :disable-views="['years', 'year', 'month', 'day']"
            :selected-date="store.proposal.start_date"
            hide-view-selector
            :on-event-click="showEventCreationDialogEdit"
            @event-drag-create="showEventCreationDialog"
            @event-change="onEventDrop"
            @dragenter.prevent
            @dragover.prevent
            class="w-4/5 cursor-pointer relative"
        >
            <template #title="{ title, view }">
                <div class="border w-56 rounded-lg mb-5">
                    <div class="flex">
                        <div class="w-3/4 flex justify-between px-4 py-2 items-center">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.5 2H16V1.5C16 1.224 15.776 1 15.5 1C15.224 1 15 1.224 15 1.5V2H5V1.5C5 1.224 4.776 1 4.5 1C4.224 1 4 1.224 4 1.5V2H1.5C0.673 2 0 2.673 0 3.5V17.5C0 18.327 0.673 19 1.5 19H18.5C19.327 19 20 18.327 20 17.5V3.5C20 2.673 19.327 2 18.5 2ZM1.5 3H4V4.5C4 4.776 4.224 5 4.5 5C4.776 5 5 4.776 5 4.5V3H15V4.5C15 4.776 15.224 5 15.5 5C15.776 5 16 4.776 16 4.5V3H18.5C18.776 3 19 3.224 19 3.5V6H1V3.5C1 3.224 1.224 3 1.5 3ZM18.5 18H1.5C1.224 18 1 17.776 1 17.5V7H19V17.5C19 17.776 18.776 18 18.5 18Z" fill="black"/>
                                <path d="M7.5 10H6.5C6.224 10 6 9.776 6 9.5C6 9.224 6.224 9 6.5 9H7.5C7.776 9 8 9.224 8 9.5C8 9.776 7.776 10 7.5 10Z" fill="black"/>
                                <path d="M10.5 10H9.5C9.224 10 9 9.776 9 9.5C9 9.224 9.224 9 9.5 9H10.5C10.776 9 11 9.224 11 9.5C11 9.776 10.776 10 10.5 10Z" fill="black"/>
                                <path d="M13.5 10H12.5C12.224 10 12 9.776 12 9.5C12 9.224 12.224 9 12.5 9H13.5C13.776 9 14 9.224 14 9.5C14 9.776 13.776 10 13.5 10Z" fill="black"/>
                                <path d="M16.5 10H15.5C15.224 10 15 9.776 15 9.5C15 9.224 15.224 9 15.5 9H16.5C16.776 9 17 9.224 17 9.5C17 9.776 16.776 10 16.5 10Z" fill="black"/>
                                <path d="M4.5 12H3.5C3.224 12 3 11.776 3 11.5C3 11.224 3.224 11 3.5 11H4.5C4.776 11 5 11.224 5 11.5C5 11.776 4.776 12 4.5 12Z" fill="black"/>
                                <path d="M7.5 12H6.5C6.224 12 6 11.776 6 11.5C6 11.224 6.224 11 6.5 11H7.5C7.776 11 8 11.224 8 11.5C8 11.776 7.776 12 7.5 12Z" fill="black"/>
                                <path d="M10.5 12H9.5C9.224 12 9 11.776 9 11.5C9 11.224 9.224 11 9.5 11H10.5C10.776 11 11 11.224 11 11.5C11 11.776 10.776 12 10.5 12Z" fill="black"/>
                                <path d="M13.5 12H12.5C12.224 12 12 11.776 12 11.5C12 11.224 12.224 11 12.5 11H13.5C13.776 11 14 11.224 14 11.5C14 11.776 13.776 12 13.5 12Z" fill="black"/>
                                <path d="M16.5 12H15.5C15.224 12 15 11.776 15 11.5C15 11.224 15.224 11 15.5 11H16.5C16.776 11 17 11.224 17 11.5C17 11.776 16.776 12 16.5 12Z" fill="black"/>
                                <path d="M4.5 14H3.5C3.224 14 3 13.776 3 13.5C3 13.224 3.224 13 3.5 13H4.5C4.776 13 5 13.224 5 13.5C5 13.776 4.776 14 4.5 14Z" fill="black"/>
                                <path d="M7.5 14H6.5C6.224 14 6 13.776 6 13.5C6 13.224 6.224 13 6.5 13H7.5C7.776 13 8 13.224 8 13.5C8 13.776 7.776 14 7.5 14Z" fill="black"/>
                                <path d="M10.5 14H9.5C9.224 14 9 13.776 9 13.5C9 13.224 9.224 13 9.5 13H10.5C10.776 13 11 13.224 11 13.5C11 13.776 10.776 14 10.5 14Z" fill="black"/>
                                <path d="M13.5 14H12.5C12.224 14 12 13.776 12 13.5C12 13.224 12.224 13 12.5 13H13.5C13.776 13 14 13.224 14 13.5C14 13.776 13.776 14 13.5 14Z" fill="black"/>
                                <path d="M16.5 14H15.5C15.224 14 15 13.776 15 13.5C15 13.224 15.224 13 15.5 13H16.5C16.776 13 17 13.224 17 13.5C17 13.776 16.776 14 16.5 14Z" fill="black"/>
                                <path d="M4.5 16H3.5C3.224 16 3 15.776 3 15.5C3 15.224 3.224 15 3.5 15H4.5C4.776 15 5 15.224 5 15.5C5 15.776 4.776 16 4.5 16Z" fill="black"/>
                                <path d="M7.5 16H6.5C6.224 16 6 15.776 6 15.5C6 15.224 6.224 15 6.5 15H7.5C7.776 15 8 15.224 8 15.5C8 15.776 7.776 16 7.5 16Z" fill="black"/>
                                <path d="M10.5 16H9.5C9.224 16 9 15.776 9 15.5C9 15.224 9.224 15 9.5 15H10.5C10.776 15 11 15.224 11 15.5C11 15.776 10.776 16 10.5 16Z" fill="black"/>
                                <path d="M13.5 16H12.5C12.224 16 12 15.776 12 15.5C12 15.224 12.224 15 12.5 15H13.5C13.776 15 14 15.224 14 15.5C14 15.776 13.776 16 13.5 16Z" fill="black"/>
                                <path d="M16.5 16H15.5C15.224 16 15 15.776 15 15.5C15 15.224 15.224 15 15.5 15H16.5C16.776 15 17 15.224 17 15.5C17 15.776 16.776 16 16.5 16Z" fill="black"/>
                            </svg>
                            <span class="text-base" v-if="view.id === 'week'">{{ view.startDate.format('DD.MM') }} - {{ view.endDate.format('DD.MM')}}</span>
                            <span class="text-base pr-2" v-else-if="view.id === 'day'">{{ view.startDate.format('DD.MM.YYYY') }}</span>
                        </div>
                        <div class="w-1/4 flex items-center justify-evenly bg-gray-200 rounded-r-lg">
                            <button @click="$refs.vuecal.previous()">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                                </svg>
                            </button>
                            <button @click="$refs.vuecal.next()">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </template>
            <template
                #events="{events, view}"
                v-for="(event, i) in events"
                :key="i"
                @dragstart="onEventDragStart($event, event)"
            >
            </template>
        </vue-cal>

        <div
            @drop="onExternalEventDrop"
            @dragenter.prevent
            @dragover.prevent
            class="w-1/5 h-152 px-6 pt-16 overflow-y-auto"
        >
            <div
                v-for="(card, i) in draggables"
                :key="i"
                draggable="true"
                @dragstart="onEventDragStart($event, card)"
                class="w-full mb-2 cursor-move"
            >
                <div
                    v-if="card.class === 'activity' && card.start === null"
                    class="p-2 rounded-lg"
                    style="background-color: #FFEFBC;"
                >
                    <p class="">{{ card.title }}</p>
                </div>
                <div
                    v-if="card.class === 'eatery' && card.start === null"
                    class="p-2 rounded-lg"
                    style="background-color: #FEE2E2;"
                >
                    <p class="">{{ card.title }}</p>
                </div>
                <div
                    v-if="card.class === 'custom' && card.start === null"
                    class="p-2 rounded-lg flex justify-between"
                    style="background-color: #D6D3ED;"
                >
                    <p class="">{{ card.title }}</p>
                  <span @click="deleteCustomEvent(card.id)" class="text-gray-600 hover:text-gray-900 cursor-pointer">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  </span>
                </div>
            </div>
          <EventModal
            :show="eventCreationDialogIsVisible"
            @close="closeEventCreationDialog()"
            :size="`max-w-xl`"

          >

            <main class="max-w-3xl p-8">
              <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-8">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Start </label>
                <div class="mt-2 sm:mt-0 sm:col-span-2">
                  <Datepicker
                      v-model="customEventForm.start"
                  />
                </div>
                <p
                    v-if="customEventForm.errors.start"
                    class="mt-2 text-sm text-red-600"
                >
                  {{ customEventForm.errors.start }}
                </p>
              </div>
              <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-8">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> End </label>
                <div class="mt-2 sm:mt-0 sm:col-span-2">
                  <Datepicker
                      v-model="customEventForm.end"
                  />
                </div>
                <p
                    v-if="customEventForm.errors.end"
                    class="mt-2 text-sm text-red-600"
                >
                {{ customEventForm.errors.end }}
                </p>
              </div>
              <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-8">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Name </label>
                <div class="mt-2 sm:mt-0 sm:col-span-2">
                  <input
                      id="name"
                      v-model="customEventForm.name"
                      name="name"
                      type="text"
                      class="block max-w-lg w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                      @change="customEventForm.clearErrors('name')"
                  >
                </div>
                <p
                    v-if="customEventForm.errors.name"
                    class="mt-2 text-sm text-red-600"
                >
                  {{ customEventForm.errors.name }}
                </p>
              </div>
              <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-8">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Description </label>
                <div class="mt-2 sm:mt-0 sm:col-span-2">
                  <textarea
                      id="description"
                      v-model="customEventForm.description"
                      rows="5"
                      class="block max-w-lg w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                      @change="customEventForm.clearErrors('description')"
                  ></textarea>
                </div>
                <p
                    v-if="customEventForm.errors.description"
                    class="mt-2 text-sm text-red-600"
                >
                  {{ customEventForm.errors.description }}
                </p>
              </div>
            </main>

            <div class="w-full flex justify-end pb-4 pr-2">
              <CreateButton
                  class="mr-2"
                  :disabled="customEventForm.processing"
                  :class="{'opacity-50 cursor-not-allowed': customEventForm.processing}"
                  @click="saveCustomEvent"
              >
                Save
              </CreateButton>
              <CancelButton
                  class="ml-2"
                  @click="closeEventCreationDialog()"
              />
            </div>
          </EventModal>

<!--          edit custom event-->

          <EventModal
            :show="customEventDialogIsVisible"
            @close="closeEventDialog()"
            :size="`max-w-xl`"

          >

            <main class="max-w-3xl p-8">
              <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-8">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Start </label>
                <div class="mt-2 sm:mt-0 sm:col-span-2">
                  <Datepicker
                    v-model="customEditEventForm.start"
                  />
                </div>
                <p
                  v-if="customEditEventForm.errors.start"
                  class="mt-2 text-sm text-red-600"
                >
                  {{ customEditEventForm.errors.start }}
                </p>
              </div>
              <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-8">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> End </label>
                <div class="mt-2 sm:mt-0 sm:col-span-2">
                  <Datepicker
                    v-model="customEditEventForm.end"
                  />
                </div>
                <p
                  v-if="customEditEventForm.errors.end"
                  class="mt-2 text-sm text-red-600"
                >
                  {{ customEditEventForm.errors.end }}
                </p>
              </div>
              <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-8">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Name </label>
                <div class="mt-2 sm:mt-0 sm:col-span-2">
                  <input
                    id="name"
                    v-model="customEditEventForm.name"
                    name="name"
                    type="text"
                    class="block max-w-lg w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                    @change="customEditEventForm.clearErrors('name')"
                  >
                </div>
                <p
                  v-if="customEditEventForm.errors.name"
                  class="mt-2 text-sm text-red-600"
                >
                  {{ customEditEventForm.errors.name }}
                </p>
              </div>
              <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-8">
                <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Description </label>
                <div class="mt-2 sm:mt-0 sm:col-span-2">
                  <textarea
                    id="description"
                    v-model="customEditEventForm.description"
                    rows="5"
                    class="block max-w-lg w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                    @change="customEditEventForm.clearErrors('description')"
                  ></textarea>
                </div>
                <p
                  v-if="customEditEventForm.errors.description"
                  class="mt-2 text-sm text-red-600"
                >
                  {{ customEditEventForm.errors.description }}
                </p>
              </div>
            </main>

            <div class="w-full flex justify-end pb-4 pr-2">
              <CreateButton
                class="mr-2"
                :disabled="customEditEventForm.processing"
                :class="{'opacity-50 cursor-not-allowed': customEditEventForm.processing}"
                @click="saveEditCustomEvent"
              >
                Save
              </CreateButton>
              <CancelButton
                class="ml-2"
                @click="closeEventDialog()"
              />
            </div>
          </EventModal>
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import VueCal from 'vue-cal'
import './css/calendar.css'
import '@vuepic/vue-datepicker/dist/main.css';
import Button from "@/Jetstream/Button";
import { useProposalOldStore } from '@/Stores/ProposalOld'
import EventModal from '@/ComponentsDeprecated/Modal/CalendarModal'
import {useForm} from "@inertiajs/vue3";
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import CancelButton from '@/ComponentsDeprecated/Buttons/CancelButton';
import CreateButton from '@/ComponentsDeprecated/Buttons/CreateButton';

const minEventWidth = ref(0)
const vuecal = ref()
const date = ref(new Date());
const showAllDayEvents = ref(0)
const store = useProposalOldStore()
const eventCreationDialogIsVisible = ref(false)
const customEventDialogIsVisible = ref(false)
const customEventEditSaving = ref(false)

let draggables = computed( function() {
    let draggables = []
    store.activities.forEach((activity) => {
        let drag = {
            id: activity.id,
            start: activity.start,
            end: activity.end,
            title: activity.name,
            class: activity.type
        }
        if (drag.start === null && drag.end === null) {
            draggables.push(drag)
        }
    })
    store.eateries.forEach((eatery) => {
        let drag = {
            id: eatery.id,
            start: eatery.start,
            end: eatery.end,
            title: eatery.name,
            class: eatery.type
        }
        if (drag.start === null && drag.end === null) {
            draggables.push(drag)
        }
    })
    store.custom.forEach((custom) => {
      let drag = {
        id: custom.id,
        start: custom.start,
        end: custom.end,
        title: custom.name,
        class: custom.type
      }
      if (drag.start === null && drag.end === null) {
        draggables.push(drag)
      }
    })
      return draggables
})

let events = computed(function() {
    let calendarEvents = []
    store.activities.forEach((activity) => {
        let event = {
            id: activity.id,
            start: activity.start ? new Date(activity.start) : null,
            end: activity.end ? new Date(activity.end) : null,
            title: activity.name,
            class: activity.type,
            allDay: activity.type === 'lodging'
        }
        if (event.start) {
            calendarEvents.push(event)
        }
    })
    store.eateries.forEach((eatery) => {
        let event = {
            id: eatery.id,
            start: eatery.start ? new Date(eatery.start) : null,
            end: eatery.end ? new Date(eatery.end) : null,
            title: eatery.name,
            class: eatery.type,
            allDay: eatery.type === 'lodging'
        }
        if (event.start) {
            calendarEvents.push(event)
        }
    })
    // store.lodging.forEach((lodging) => {
    //     let event = {
    //         id: lodging.id,
    //         start: lodging.start ? new Date(lodging.start) : null,
    //         end: lodging.end ? new Date(lodging.end) : null,
    //         title: lodging.name,
    //         class: lodging.type,
    //         allDay: lodging.type === 'lodging'
    //     }
    //     if (event.start) {
    //         calendarEvents.push(event)
    //     }
    // })

  store.custom.forEach((custom) => {
    let event = {
      id: custom.id,
      start: custom.start ? new Date(custom.start) : null,
      end: custom.end ? new Date(custom.end) : null,
      title: custom.name,
      content: custom.description,
      class: custom.type,
      allDay: custom.type === 'lodging'
    }
    if (event.start) {
      calendarEvents.push(event)
    }
  })
    return calendarEvents
})

const format = (date) => {
    const day = date.getDate().toLocaleString('nb-NO', {day:'2-digit'});
    const month = parseInt(date.getMonth().toLocaleString('nb-NO', {month:'2-digit'})) + 1;
    const year = date.getFullYear();
    const hours = date.getHours().toLocaleString('nb-NO');
    const min = date.getMinutes().toLocaleString('nb-No');

    return `${year}-${month}-${day}, ${hours}:${min}`;
}

function onEventDragStart (e, draggable) {
    // Passing the event's data to Vue Cal through the DataTransfer object.
    if (draggable.length > 1) {
        draggable.find(obj => {
            e.dataTransfer.setData('data', JSON.stringify(obj))
            e.dataTransfer.setData('cursor-grab-at',  e.offsetY)
        });
    } else {
        e.dataTransfer.setData('event', JSON.stringify(draggable))
        e.dataTransfer.setData('cursor-grab-at',  e.offsetY)
    }
}

function onExternalEventDrop (e) {
    const getObj = JSON.parse(e.dataTransfer.getData('event'))
    axios.put(route('api.proposal.itinerary.update', {proposal: store.proposal.id, itinerary: getObj.id}), {
        start: null,
        end: null
    })
    if(getObj.class === 'activity') {
        const index = store.activities.findIndex(obj => {
            return obj.id === getObj.id;
        });
        store.activities[index].start = null;
        store.activities[index].end = null;
    }
    if(getObj.class === 'eatery') {
        const index = store.eateries.findIndex(obj => {
            return obj.id === getObj.id;
        });
        store.eateries[index].start = null;
        store.eateries[index].end = null;
    }
    if(getObj.class === 'lodging') {
        const index = store.lodging.findIndex(obj => {
            return obj.id === getObj.id;
        });
        store.lodging[index].start = null;
        store.lodging[index].end = null;
    }
    if(getObj.class === 'custom') {
        const index = store.custom.findIndex(obj => {
          return obj.id === getObj.id;
        });
        store.custom[index].start = null;
        store.custom[index].end = null;
    }
}

function onEventDrop ({ event, originalEvent, external }) {
    if (event) {
        const start = event.start;
        const end = event.end;
        if(event.id) {
          axios.put(route('api.proposal.itinerary.update', {proposal: store.proposal.id, itinerary: event.id}), {
            start: start,
            end: end
          })
          if(event.class === 'activity') {
            const index = store.activities.findIndex(obj => {
              return obj.id === event.id;
            });
            store.activities[index].start = event.start;
            store.activities[index].end = event.end;
          }
          if(event.class === 'eatery') {
            const index = store.eateries.findIndex(obj => {
              return obj.id === event.id;
            });
            store.eateries[index].start = event.start;
            store.eateries[index].end = event.end;
          }
          if(event.class === 'lodging') {
            const index = store.lodging.findIndex(obj => {
              return obj.id === event.id;
            });
            store.lodging[index].start = event.start;
            store.lodging[index].end = event.end;
          }

          if(event.class === 'custom') {
            const index = store.custom.findIndex(obj => {
              return obj.id === event.id;
            });
            store.custom[index].start = event.start;
            store.custom[index].end = event.end;
          }
        }
    }
    // If the event is external, delete it from the data source on drop into Vue Cal.
    // If the event comes from another Vue Cal instance, it will be deleted automatically in there.
    if (external) {
        if (originalEvent.class === 'activity') {
            const start = event.start;
            const end = event.end;
            axios.put(route('api.proposal.itinerary.update', {proposal: store.proposal.id, itinerary: event.id}), {
                start: start,
                end: end
            })
            if(originalEvent.class === 'activity') {
                const index = store.activities.findIndex(obj => {
                    return obj.id === originalEvent.id;
                });
                store.activities[index].start = event.start;
                store.activities[index].end = event.end;
            }
            const extEventToDeletePos = draggables.value.findIndex(card => card.id === originalEvent.id)
            if (extEventToDeletePos > -1) draggables.value.splice(extEventToDeletePos, 1)
        }
        if (originalEvent.class === 'eatery') {
            const start = event.start;
            const end = event.end;
            axios.put(route('api.proposal.itinerary.update', {proposal: store.proposal.id, itinerary: event.id}), {
                start: start,
                end: end
            })
            if(originalEvent.class === 'eatery') {
                const index = store.eateries.findIndex(obj => {
                    return obj.id === originalEvent.id;
                });
                store.eateries[index].start = event.start;
                store.eateries[index].end = event.end;
            }
            const extEventToDeletePos = draggables.value.findIndex(card => card.id === event.id)
            if (extEventToDeletePos > -1) draggables.value.splice(extEventToDeletePos, 1)
        }
        if (originalEvent.class === 'lodging') {
            const start = event.start;
            const end = event.end;
            axios.put(route('api.proposal.itinerary.update', {proposal: store.proposal.id, itinerary: event.id}), {
                start: start,
                end: end
            })
            if(originalEvent.class === 'lodging') {
                const index = store.lodging.findIndex(obj => {
                    return obj.id === originalEvent.id;
                });
                store.lodging[index].start = event.start;
                store.lodging[index].end = event.end;
            }
            const extEventToDeletePos = draggables.value.findIndex(card => card.id === event.id)
            if (extEventToDeletePos > -1) draggables.value.splice(extEventToDeletePos, 1)
        }
      if (originalEvent.class === 'custom') {
        const start = event.start;
        const end = event.end;
        axios.put(route('api.proposal.itinerary.update', {proposal: store.proposal.id, itinerary: event.id}), {
          start: start,
          end: end
        })
        if(originalEvent.class === 'custom') {
          const index = store.custom.findIndex(obj => {
            return obj.id === originalEvent.id;
          });
          store.custom[index].start = event.start;
          store.custom[index].end = event.end;
        }
        const extEventToDeletePos = draggables.value.findIndex(card => card.id === event.id)
        if (extEventToDeletePos > -1) draggables.value.splice(extEventToDeletePos, 1)
      }
    }
}


const customEventForm = useForm({
  name: '',
  description: '',
  start: '',
  end: '',
});
const customEditEventForm = useForm({
  name: '',
  description: '',
  start: '',
  end: '',
});
const customEventEvent = ref(null);
const customEditEvent = ref(null);

function closeEventCreationDialog()
{
  eventCreationDialogIsVisible.value = false
  store.fetchCustom();
}
function closeEventDialog()
{
  customEventDialogIsVisible.value = false
}
function showEventCreationDialog(event)
{
  customEventEvent.value = event
  customEventForm.start = event.start
  customEventForm.end = event.end
  eventCreationDialogIsVisible.value = true
}
function showEventCreationDialogEdit(event)
{
  if (event.class === 'custom') {
    customEditEvent.value = event
    customEditEventForm.start = event.start
    customEditEventForm.end = event.end
    customEditEventForm.name = event.title
    customEditEventForm.description = event.content
    customEventDialogIsVisible.value = true
  }
}
function saveCustomEvent() {

  axios.post(route('api.custom-itinerary.store'), {
    name: customEventForm.name,
    description: customEventForm.description,
    type: 'custom'
  }).then((response) => {
    eventCreationDialogIsVisible.value = false
    axios.post(route('api.proposal.destination.itinerary.store', {proposal: store.proposal.id, destination: store.proposal.places[0].id, type: 'custom'}), {
      custom_itinerary_id: response.data.id,
      description: customEventForm.description,
      name: customEventForm.name,
      start: customEventForm.start,
      end: customEventForm.end
    }).then((response) => {
      store.fetchCustom();
      customEventForm.reset('name', 'description')
    })
  }).catch((error) => {
    console.log(error);
  });
}
function saveEditCustomEvent() {
  customEventEditSaving.value = true;
  axios.put(route('api.proposal.destination.itinerary.update', {proposal: store.proposal.id, destination: store.proposal.places[0].id, itinerary: customEditEvent.value.id }), {
      description: customEditEventForm.description,
      name: customEditEventForm.name,
      start: customEditEventForm.start,
      end: customEditEventForm.end
    }).then((response) => {
      store.fetchCustom();
      customEditEventForm.reset('name', 'description')
      customEventEditSaving.value = false;
      closeEventDialog()
    });
}
function deleteCustomEvent(event_id) {
  axios.delete(route('api.proposal.destination.itinerary.destroy', {proposal: store.proposal.id, destination: store.proposal.places[0].id, itinerary: event_id}))
  .then((response) => {
    store.fetchCustom();
  })
}

</script>
